<template>
  <div>
    <el-row class="select-other-info" v-if="optionItem.ownerCode ">
      <span class="core-goods-title">货主编码:  </span>
      {{ optionItem.ownerCode }}
    </el-row>
    <el-row class="select-other-info" v-if="optionItem.id ">
      <span class="core-goods-title">货品ID:  </span>
      {{ optionItem.id }}
    </el-row>
    <el-row class="select-other-info" v-if="optionItem.code ">
      <span class="core-goods-title">货品编号:  </span>
      {{ optionItem.code }}
    </el-row>

    <el-row class="select-other-info" v-if="optionItem.typeId ">
      <span class="core-goods-title">货品分类:  </span>
      {{ formatGoodsTypeList(optionItem.typeId) }}
    </el-row>
    <div class="select-other-info" v-if="optionItem.dosageForm">
      <span class="core-goods-title">剂型: </span>
      <dict :dict-group="'dosageForm'" :dict-key="optionItem.dosageForm"></dict>
    </div>
    <div class="select-other-info" v-if="optionItem.packingSpecification">
      <span class="core-goods-title">包装规格: </span>{{optionItem.packingSpecification}}
    </div>
    <div class="select-other-info">
      <span class="core-goods-title">规格: </span>
      {{ optionItem.specifications}}
    </div>
    <div class="select-other-info" v-if="optionItem.factoryName">
      <span class="core-goods-title">生产厂商: </span>
      {{ optionItem.factoryName}}
    </div>
    <div class="select-other-info" v-if="optionItem.approvalNumber">
      <span class="core-goods-title">批准文号: </span>
      {{optionItem.approvalNumber}}
    </div>
    <div class="select-other-info" v-if="optionItem.minTagUnitCount">
      <span class="core-goods-title">最小赋码单位所含最小计价单位数量: </span>
      {{optionItem.minTagUnitCount}}
    </div>
    <div class="select-other-info" v-if="optionItem.origin">
      <span class="core-goods-title">国家或地区: </span>
      {{optionItem.origin}}
    </div>
    <div class="select-other-info" v-if="optionItem.registrationNumber">
      <span class="core-goods-title">进口注册证号: </span>
      {{optionItem.registrationNumber}}
    </div>
    <div class="select-other-info" v-if="optionItem.goodsApprovalNOValidity">
      <span :class="formatWarning(optionItem.goodsApprovalNOValidity)&&type==1?'red-warning':'core-goods-title'">批准文号有效期: {{formatTime(optionItem.goodsApprovalNOValidity)}}  </span>
      <span v-if="formatWarning(optionItem.goodsApprovalNOValidity)&&type==1" class="red-warning">已过期,请更新</span>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'coreGoodsField',
    props: {
      optionItem: {
        required: true,
        type: Object
      },
      type:{
        type:Number,
        default:0
      }
    },
    methods: {
      formatGoodsTypeList(val) {
        let goodsTypeList = this.$store.state.goodsTypeList;
        return goodsTypeList[val - 1] && goodsTypeList[val - 1].label || val;
      },
      formatWarning(val){
        if(this.$moment(val).isBefore(this.$moment())){
          return true
        }
        return false
      },
      formatTime(val){
        if(val){
          return this.$moment(val).format('YYYY-MM-DD')
        }
      }
    }
  };
</script>
<style  lang="scss">
.red-warning{
  color: red;
}

</style>
